function getEnvironment() {
  const meta = document.querySelector('meta[name="server-environment"]');

  return meta ? meta.getAttribute("content") : undefined;
}

const isDataSaving = () => document.documentElement.hasAttribute("data-save-data");

const isDevelopment = () => getEnvironment() === 'development';

const isProduction = () => !isDevelopment();

const isStaging = () => getEnvironment() === 'staging';

export {
  getEnvironment,
  isDataSaving,
  isDevelopment,
  isProduction,
  isStaging,
};



// WEBPACK FOOTER //
// ./shared/helpers/environment.js